<template>
  <!--  FAQ-カテゴリ&質問選択 -->
  <div v-if="category" class="pt255 container-fluid">
    <faq-header :breadcrumb="category"></faq-header>

    <div v-if="categoryList && categoryList.length > 0" class="section">
      <div class="title-block">
        <div class="section">カテゴリ</div>
      </div>
      <div class="category">
        <div class="row row-cols-2 row-cols-md-3">
          <template v-for="(category,idx) in categoryList">
            <div class="col mb-4" :key="`category_${category.LEVEL_NO}`" >
              <a @click="onCategoryClick(category.LEVEL_NO)" class="card category" >
                <div class="card-body d-flex flex-column justify-content-center">
                  <h5>{{ category.LEVEL_NM }}</h5>
                </div>
              </a>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div v-if="faqList && faqList.length > 0"  class="section">
      <div class="title-block">
        <div class="section">質問</div>
      </div>
      <div class="my-2 text-center text-muted">{{total}}件中の{{(pageNo - 1) * pageSize + 1}} - {{ pageNo * pageSize > total ? total : pageNo * pageSize }}番目を表示</div>

      <ul class="list-group">
        <a @click="onFaqClick(faq.FAQ_NO)" :key="`faq_${faq.FAQ_NO}`" v-for="(faq,idx) in faqList" class="faq d-flex list-group-item text-break">
          <span class="badge light">{{ (pageNo - 1) * pageSize + idx + 1}}</span>
          {{ faq.QUESTION }}
        </a>
      </ul>

      <div class="mt-4 row justify-content-center">
        <div class="col-5 col-lg-3">
          <a @click="prevPage()" v-if="pageNo > 1" class="btn btn-primary" href="javascript:;" role="button">前のページ</a>
        </div>
        <div v-if="pageNo < totalPage" class="col-5 col-lg-3">
          <a @click="nextPage()" class="btn btn-primary" href="javascript:;" role="button">次のページ</a>
        </div>
      </div>
    </div>

    <div v-if="(!categoryList || categoryList.length === 0) && (!faqList || faqList.length === 0) " class="my-2 text-center text-muted">検索条件に一致するデータがありませんでした。</div>
  </div>



</template>

<script>

/*
* Import libs and componnents
*/
import Loading from 'vue-loading-overlay';
import SiteConstants from 'assets/const/SiteConstants.json';
import axios from "assets/js/request";

export default {
  /*
  * Name of component
  */
  name: "PT255FAQListParts",
  props:{
    ptInitData: {
      type: Object,
      default: null,
    }
  },
  /*
  * Get data from parent component
  */
  components:{
        Loading,
        FaqHeader: () => import('./components/FaqHeader.vue')
    },
    data() {
      return {
        category: null,
        categoryList: [],
        pageNo: 1,
        pageSize: 20,
        faqList: [],
        total: 0,
        totalPage: 0
      }
  },
  mounted() {
    if (this.ptInitData){
      this.category = this.ptInitData.category;
      this.categoryList = this.ptInitData.categoryList;
      this.faqList = this.ptInitData.faqList;
      this.total = this.ptInitData.total;
      this.totalPage = this.ptInitData.totalPage;
    }
  },
  methods: {
    onCategoryClick(categoryNo){
      this.$router.push({ name: SiteConstants.PG010, query: {pageNo: 51, categoryNo : categoryNo}});
    },
    onFaqClick(faqNo){
      this.$router.push({ name: SiteConstants.PG010, query: {pageNo: 52, faqNo : faqNo}});
    },
    doSearch() {
      this.faqList = [];
      this.$emit("event-loading", true);
      axios.post(this.$UrlConstants.ECSITE + this.$UrlConstants.PT255 + this.$UrlConstants.DO_INIT, {
        categoryNo: this.category.LEVEL_NO,
        pageNo: this.pageNo,
      }).then((response) => {
        this.faqList = response.data.faqList;
        this.total = response.data.total;
        this.totalPage = response.data.totalPage;
      }).catch((error) => {
        common.errorAPI(error);
      }).finally(() => {
        this.$emit("event-loading", false);
      });
    },
    nextPage(){
      this.pageNo = this.pageNo + 1;
      this.doSearch();
    },
    prevPage(){
      this.pageNo = this.pageNo - 1;
      this.doSearch();
    },
  },
}
</script>

